<template>
  <div>
    <hr />
    <div class="row">
      <div class="col-12 bg-secondaryL p-3 my-auto">
        <h4 class="d-inline-block">Destination Customer</h4>
        <a href="#" @click="refreshTransfer">
          <img
            src="@/assets/img/refresh_icon.png"
            class="my-auto float-right d-inline"
            alt="Refesh Icon"
          />
        </a>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <!-- {{this.$store.state.customers.destinationCustomer}} -->
        <!-- col 12 start -->
        <!-- This is the search. It is the same as the main search on the dashboard with an added row called create new customer -->
        <!-- The create new customer row should always show without typing and then as the user types it then shows the message or the customers like the main search -->
        <!-- When a customer is selected it then dicplays all the fields completed -->
        <!-- If new customer is clicked all the fields are then shown empty to complete -->
        <div class="row my-3">
          <div class="col-md-6">
            <div class="row">
              <div class="col-12">
                <h5 class="mt-3 pb-2">Existing Customer</h5>
              </div>
            </div>
            <div class="input-group mobile-space-t db_search">
              <input
                autofocus
                v-model="searchId"
                @keyup="search"
                class="form-control form-control-lg"
                type="text"
                placeholder="Search"
                aria-label="Search"
              />
              <div class="input-group-append">
                <span class="input-group-text amber lighten-3" id="basic-text1">
                  <i class="fa fa-search text-grey" aria-hidden="true"></i>
                </span>
              </div>
            </div>
            <div class="col-sm-12 no-pad bg-white db-search-results db-search-results-transfer">
              <div
                v-if="(results && (results == 0 || !results)) && searchId.length > 0"
                class="row"
              >
                <div class="col-sm">
                  <div class="mx-auto p-3">
                    <h5>Search Results:</h5>
                    <p class="d-inline">Sorry, no results found just yet......</p>
                  </div>
                </div>
              </div>
              <div v-else-if="results && results.length >= 1 && searchId.length > 2" class="row">
                <div class="col-sm">
                  <div class="mx-auto p-3">
                    <template>
                      <b-table
                        @row-clicked="setDestinationCustomer"
                        responsive
                        hover
                        outlined
                        striped
                        :items="results"
                        :fields="searchResultFields"
                      >
                        <template slot="ref" slot-scope="data">{{data.item.ref}}</template>
                        <template slot="name" slot-scope="data">{{data.item.name}}</template>
                        <template slot="address" slot-scope="data">{{data.item.address}}</template>
                      </b-table>
                    </template>
                  </div>
                </div>
              </div>
            </div>
            <!-- When a customer is selected -->
            <div v-if="!createCustomer && destinationCustomer">
              <div class="col-12 no-pad mt-3">
                <h5 class="pb-2">Selected Customer</h5>
              </div>
              <div class="col-12 no-pad">
                <template>
                  <b-table
                    responsive
                    outlined
                    striped
                    :items="[destinationCustomer]"
                    :fields="selectedCustomer"
                  >
                    <template slot="ref" slot-scope="data">{{data.item.ref}}</template>
                    <template slot="name" slot-scope="data">{{data.item.name}}</template>
                    <template slot="address" slot-scope="data">{{data.item.address}}</template>
                  </b-table>
                </template>
              </div>
            </div>
          </div>
          <!-- Search end -->
          <div class="col-md-6">
            <div class="row">
              <div class="col-12">
                <h5 class="pl-2 mt-3 pb-2">New Customer</h5>
              </div>
            </div>
            <div class="mx-auto pl-2">
              <div @click="createNewCustomer">
                <a href="#">
                  <img src="@/assets/img/add_icon_hcg.png" class="d-inline mr-2" alt="Add icon" />
                  <p class="d-inline">Create a New Customer</p>
                </a>
              </div>
            </div>
          </div>
        </div>
        <!-- col 6 and 6 row end -->
      </div>
      <!-- col 12 end -->
    </div>
    <!-- row end -->

    <!-- <div class="row" v-if="!createCustomer && destinationCustomer">
            <div class="col-12">
                <div class="row">
                    <div class="col-sm-6 offset-sm-3 border border-secondary brs p-3 text-center">
                        <div class="h-100 pt-3">
                            <div class="d-flex justify-content-center align-items-center">
                                <img src="@/assets/img/tick_selector.png" class="img-fluid d-inline-block" alt="Transfer complete">
                                <p class="d-inline-block my-auto pl-2">Transfer Complete</p>
                            </div>
                            <div class="mt-4 font-weight-bold"><a href="#" class="underline" @click="oldCustomer">1 -
                                    View old customer</a></div>
                            <div class="mt-4 font-weight-bold pb-3"><a href="#" class="underline" @click="newCustomer">2
                                    - View new customer</a></div>
                        </div>
                    </div>
                </div>
            </div>
    </div>-->
    <div v-if="createCustomer">
      <div class="row mt-4">
        <hr />
        <div class="col-md-6">
          <div class="row">
            <div class="col-12">
              <h5>Customer Info</h5>
              <p class="d-inline text-danger font-weight-bold">Please note:</p>
              <p class="d-inline ml-1">All fields marked with * are mandatory.</p>
            </div>
          </div>
          <!-- ct start -->
          <div class="row mt-4">
            <div class="col-12 col-xl-4 my-auto">
              <label for="customerType">
                Customer Type:
                <span v-if="!$v.newCustomer.CustomerType.required">*</span>
              </label>
            </div>
            <div class="col-12 col-xl-8">
              <div class="btn-group d-block w-100">
                <div class="form-group my-auto">
                  <b-form-select
                    id="customerType"
                    v-model="newCustomer.CustomerType"
                    class="form-control"
                    :class="{ 'is-invalid': submitted && $v.newCustomer.CustomerType.$error }"
                  >
                    <option value="Consumer">Consumer</option>
                    <option value="Landlord">Landlord</option>
                    <option value="Occupier">Occupier</option>
                  </b-form-select>
                  <div
                    v-if="submitted && !$v.newCustomer.CustomerType.required"
                    class="invalid-feedback"
                  >Please select a customer type.</div>
                </div>
              </div>
            </div>
          </div>
          <!-- ct end -->

          <!-- cn start -->
          <div class="row mt-3">
            <div class="col-12 col-xl-4">
              <label for="customerName">
                Customer Name:
                <span v-if="!$v.newCustomer.CustomerName.required">*</span>
              </label>
            </div>
            <div class="col-12 col-xl-8 mt--20">
              <b-form-input
                id="customerName"
                type="text"
                v-model="newCustomer.CustomerName"
                class="form-control underline mt-2"
                :class="{ 'is-invalid': submitted && $v.newCustomer.CustomerName.$error }"
              />
              <div
                v-if="submitted && !$v.newCustomer.CustomerName.required"
                class="invalid-feedback"
              >Please provide a customer name.</div>
            </div>
          </div>
          <!-- cn end -->

          <!-- billing group start -->
          <div class="row mt-4">
            <div class="col-12 col-xl-4 my-auto">
              <label for="billingGroups">
                Billing Group:
                <span v-if="!$v.newCustomer.BillingGroups.required">*</span>
              </label>
            </div>
            <div class="col-12 col-xl-8">
              <div class="btn-group d-block w-100">
                <div class="form-group my-auto">
                  <b-form-select
                    id="billingGroups"
                    v-model="newCustomer.BillingGroups"
                    class="form-control"
                    :class="{ 'is-invalid': submitted && $v.newCustomer.BillingGroups.$error }"
                  >
                   <option
                    v-for="(billingGroup, index) in billingGroups"
                    :key="index"
                    :value="billingGroup.value"
                  >{{billingGroup.name}}</option>
                  </b-form-select>
                  <div
                    v-if="submitted && !$v.newCustomer.BillingGroups.required"
                    class="invalid-feedback"
                  >Please select a billing group.</div>
                </div>
              </div>
            </div>
          </div>
          <!-- billing group end -->

          <!-- collection method start -->
          <div class="row mt-4">
            <div class="col-12 col-xl-4 my-auto">
              <label for="collectionMethod">
                Collection Method:
                <span v-if="!$v.newCustomer.CollectionMethod.required">*</span>
              </label>
            </div>
            <div class="col-12 col-xl-8">
              <div class="btn-group d-block w-100">
                <div class="form-group my-auto">
                 <b-form-select
                  id="collectionMethod"
                  v-model="collectionMethod"
                  class="form-control"
                  :class="{ 'is-invalid': submitted && $v.newCustomer.CollectionMethod.$error }"
                  >
                  <option
                    v-for="method in collectionMethods"
                    :key="method.value"
                    :value="method.value"
                  >
                    {{ method.name }}
                  </option>
                </b-form-select>
                  <div
                    v-if="submitted && !$v.newCustomer.CollectionMethod.required"
                    class="invalid-feedback"
                  >Please select a collection method.</div>
                </div>
              </div>
            </div>
          </div>

          <div v-if="collectionMethod == 'DDFIX'" class="row mt-4">
            <div class="col-12 col-xl-4 my-auto">
              <label for="RegularCollectionAmount">
                Collection Amount:
                <span>*</span>
              </label>
            </div>
            <div class="col-12 col-xl-8">
              <div class="btn-group d-block w-100">
                <div class="form-group my-auto">
                  <b-form-input
                    id="RegularCollectionAmount"
                    v-model="regularCollectionAmount"
                    type="text"
                    placeholder="Eg: 10.00"
                    class="form-control underline mt-2"
                    :class="{ 'is-invalid': submitted && $v.newCustomer.RegularCollectionAmount.$error }"
                  />
                  <div
                    v-if="submitted && !$v.newCustomer.RegularCollectionAmount.required"
                    class="invalid-feedback"
                  >Please provide a collection amount.</div>
                  <div
                    v-if="submitted && (!$v.newCustomer.RegularCollectionAmount.decimal || !$v.newCustomer.RegularCollectionAmount.minValue)"
                    class="invalid-feedback"
                  >Please enter a valid amount.</div>
                </div>
              </div>
            </div>
          </div>

          <div v-if="collectionMethod == 'DDFIX'" class="row mt-4">
            <div class="col-12 col-xl-4 my-auto">
              <label for="CollectionDays">
                Collection Days:
                <span>*</span>
              </label>
            </div>
            <div class="col-12 col-xl-8">
              <multiselect
                v-model="daysOfMonth"
                :options="dayOpts"
                open-direction="top"
                :maxHeight="240"
                :multiple="true"
                :close-on-select="false"
                :clear-on-select="false"
                :preserve-search="true"
                placeholder="Collection day(s)"
              >
                <template slot="selection" slot-scope="{ values, isOpen }">
                  <span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">
                    {{ values.length }}
                    day
                    <span
                      v-if="values.length > 1"
                    >s</span>
                    selected
                  </span>
                </template>
              </multiselect>
              <div
                v-if="submitted && (!$v.newCustomer.DaysOfMonth.required || !$v.newCustomer.DaysOfMonth.minLength)"
                class="invalid-feedback"
                style="display: block"
              >Please select at least one collection day.</div>
            </div>
          </div>
          <!-- collection method end -->

          <!-- bill delivery method start -->
          <div class="row mt-4">
            <div class="col-12 col-xl-4 my-auto">
              <label for="billDelivery">
                Bill Delivery Method:
                <span v-if="!$v.newCustomer.BillDeliveryMethods.required">*</span>
              </label>
            </div>
            <div class="col-12 col-xl-8">
              <div class="btn-group d-block w-100">
                <div class="form-group my-auto">
                  <b-form-select
                    id="billDelivery"
                    v-model="newCustomer.BillDeliveryMethods"
                    class="form-control"
                    :class="{ 'is-invalid': submitted && $v.newCustomer.BillDeliveryMethods.$error }"
                  >
                    <option value="Post">Post</option>
                    <option value="Email">Email</option>
                    <option value="Manual">Manual</option>
                  </b-form-select>
                  <div
                    v-if="submitted && !$v.newCustomer.BillDeliveryMethods.required"
                    class="invalid-feedback"
                  >Please select a delivery method.</div>
                </div>
              </div>
            </div>
          </div>
          <!-- bill delivery method end -->

          <div class="row mt-3">
            <div class="col-12 col-xl-4">
              <label for="CollectionDueDays">Collection Due:</label>
            </div>
            <div class="col-6 mt--20">
              <b-form-input
                id="CollectionDueDays"
                type="number"
                v-model.number="collectionDueDays"
                class="form-control underline mt-2"
              />
            </div>
            <div class="col-auto">days</div>
          </div>

          <div class="row mt-3">
            <div class="col-12 col-xl-4">
              <label for="paymentDueDays">Payment Due:</label>
            </div>
            <div class="col-6 mt--20">
              <b-form-input
                id="paymentDueDays"
                type="number"
                v-model.number="paymentDueDays"
                class="form-control underline mt-2"
              />
            </div>
            <div class="col-auto">days</div>
          </div>
        </div>
        <!-- 6 col close -->
      </div>
      <!-- main row close -->
      <hr />
      <div class="row">
        <div class="col-md-6">
          <div class="row">
            <div class="col-12">
              <h5>Contact</h5>
            </div>
          </div>

          <div class="row mt-3">
            <!-- jt start -->
            <div class="col-12 col-xl-4">
              <label for="primaryJobTitle">
                Job Title:
                <span
                  v-if="newCustomer.PrimaryContact.JobTitle == '' && newCustomer.PrimaryContact.FirstName == '' && newCustomer.PrimaryContact.LastName == ''"
                >*</span>
              </label>
            </div>
            <div class="col-12 col-xl-8 mt--20">
              <b-form-input
                id="primaryJobTitle"
                type="text"
                v-model="newCustomer.PrimaryContact.JobTitle"
                class="form-control underline mt-2"
                :class="{ 'is-invalid': submitted && $v.newCustomer.PrimaryContact.JobTitle.$error }"
              />
              <div
                class="invalid-feedback"
                v-if="submitted && !$v.newCustomer.PrimaryContact.JobTitle.required"
              >Please provide a job title.</div>
            </div>
          </div>
          <!-- jt end -->

          <!-- title start -->
          <div class="row mt-4">
            <div class="col-12 col-xl-4 my-auto">
              <label for="primaryTitle">Title:</label>
            </div>
            <div class="col-12 col-xl-8">
              <div class="btn-group d-block w-100">
                <div class="form-group my-auto">
                  <b-form-select
                    id="primaryTitle"
                    v-model="newCustomer.PrimaryContact.Title"
                    class="form-control"
                  >
                    <option>Mr</option>
                    <option>Mrs</option>
                    <option>Ms</option>
                    <option>Miss</option>
                  </b-form-select>
                </div>
              </div>
            </div>
          </div>
          <!-- title end -->

          <!-- fn start -->
          <div class="row mt-3">
            <div class="col-12 col-xl-4">
              <label for="primaryFirstName">
                First name:
                <span
                  v-if="newCustomer.PrimaryContact.JobTitle == '' && newCustomer.PrimaryContact.FirstName == '' && newCustomer.PrimaryContact.LastName == ''"
                >*</span>
              </label>
            </div>
            <div class="col-12 col-xl-8 mt--20">
              <b-form-input
                id="primaryFirstName"
                type="text"
                v-model="newCustomer.PrimaryContact.FirstName"
                class="form-control underline mt-2"
                :class="{ 'is-invalid': submitted && $v.newCustomer.PrimaryContact.FirstName.$error }"
              />
              <div
                class="invalid-feedback"
                v-if="submitted && !$v.newCustomer.PrimaryContact.FirstName.required"
              >Please provide a first name.</div>
            </div>
          </div>
          <!-- fn end -->

          <!-- ln start -->
          <div class="row mt-3">
            <div class="col-12 col-xl-4">
              <label for="primaryLastName">
                Last name:
                <span
                  v-if="newCustomer.PrimaryContact.JobTitle == '' && newCustomer.PrimaryContact.FirstName == '' && newCustomer.PrimaryContact.LastName == ''"
                >*</span>
              </label>
            </div>
            <div class="col-12 col-xl-8 mt--20">
              <b-form-input
                id="primaryLastName"
                type="text"
                v-model="newCustomer.PrimaryContact.LastName"
                class="form-control underline mt-2"
                :class="{ 'is-invalid': submitted && $v.newCustomer.PrimaryContact.LastName.$error }"
              />
              <div
                class="invalid-feedback"
                v-if="submitted && !$v.newCustomer.PrimaryContact.LastName.required"
              >Please provide a last name.</div>
            </div>
          </div>
          <!-- ln end -->

          <!-- landline start -->
          <div class="row mt-3">
            <div class="col-12 col-xl-4">
              <label for="primaryLandline">
                Landline:
                <span
                  v-if="newCustomer.CustomerType == 'Consumer' && newCustomer.PrimaryContact.Landline == '' && newCustomer.PrimaryContact.Mobile == '' && newCustomer.PrimaryContact.Email == ''"
                >*</span>
              </label>
            </div>
            <div class="col-12 col-xl-8 mt--20">
              <b-form-input
                id="primaryLandline"
                type="text"
                v-model="newCustomer.PrimaryContact.Landline"
                class="form-control underline mt-2"
                :class="{ 'is-invalid': submitted && $v.newCustomer.PrimaryContact.Landline.$error }"
              />
              <div
                class="invalid-feedback"
                v-if="submitted && !$v.newCustomer.PrimaryContact.Landline.required"
              >Please provide a landline number.</div>
            </div>
          </div>
          <!-- landline end -->

          <!-- mobile start -->
          <div class="row mt-3">
            <div class="col-12 col-xl-4">
              <label for="primaryMobile">
                Mobile:
                <span
                  v-if="newCustomer.CustomerType == 'Consumer' && newCustomer.PrimaryContact.Landline == '' && newCustomer.PrimaryContact.Mobile == '' && newCustomer.PrimaryContact.Email == ''"
                >*</span>
              </label>
            </div>
            <div class="col-12 col-xl-8 mt--20">
              <b-form-input
                id="primaryMobile"
                type="text"
                v-model="newCustomer.PrimaryContact.Mobile"
                class="form-control underline mt-2"
                :class="{ 'is-invalid': submitted && $v.newCustomer.PrimaryContact.Mobile.$error }"
              />
              <div
                class="invalid-feedback"
                v-if="submitted && !$v.newCustomer.PrimaryContact.Mobile.required"
              >Please provide a mobile phone number.</div>
            </div>
          </div>
          <!-- mobile end -->

          <div class="row mt-3">
            <!-- fax start -->
            <div class="col-12 col-xl-4">
              <label for="primaryFax">Fax:</label>
            </div>
            <div class="col-12 col-xl-8 mt--20">
              <input
                id="primaryFax"
                v-model="newCustomer.PrimaryContact.Fax"
                type="number"
                step="1"
                maxlength="30"
                class="form-control underline mt-2"
                name="Fax"
                pattern
              />
            </div>
          </div>
          <!-- fax end -->

          <!-- email start -->
          <div class="row mt-3">
            <div class="col-12 col-xl-4">
              <label for="primaryEmail">
                Email:
                <span
                  v-if="newCustomer.CustomerType == 'Consumer' && newCustomer.PrimaryContact.Landline == '' && newCustomer.PrimaryContact.Mobile == '' && newCustomer.PrimaryContact.Email == ''"
                >*</span>
              </label>
            </div>
            <div class="col-12 col-xl-8 mt--20">
              <b-form-input
                id="primaryEmail"
                type="text"
                v-model="newCustomer.PrimaryContact.Email"
                class="form-control underline mt-2"
                :class="{ 'is-invalid': submitted && $v.newCustomer.PrimaryContact.Email.$error }"
              />
              <div
                class="invalid-feedback"
                v-if="!$v.newCustomer.PrimaryContact.Email.email"
              >Please enter a valid email address.</div>
              <div
                class="invalid-feedback"
                v-if="submitted && !$v.newCustomer.PrimaryContact.Email.required"
              >Please provide an email address.</div>
            </div>
          </div>
          <!-- email end -->
        </div>
        <!-- col 6 close -->
        <div class="col-md-6">
          <!-- sa1 start -->
          <div class="row mt-3">
            <div class="col-12 col-xl-4">
              <label for="primaryLine1">
                Street address:
                <span v-if="!$v.newCustomer.PrimaryContact.Address.Line1.required">*</span>
              </label>
            </div>
            <div class="col-12 col-xl-8 mt--20">
              <input
                id="primaryLine1"
                type="text"
                class="form-control underline mt-2"
                v-model="newCustomer.PrimaryContact.Address.Line1"
                :class="{ 'is-invalid': submitted && $v.newCustomer.PrimaryContact.Address.Line1.$error }"
              />
              <div
                class="invalid-feedback"
                v-if="submitted && !$v.newCustomer.PrimaryContact.Address.Line1.required"
              >Please provide a street address</div>
              <div
                  class="invalid-feedback"
                  v-if="submitted && !$v.newCustomer.PrimaryContact.Address.Line1.maxLength"
              >Line 1 of the address must not exceed 40 characters</div>
          </div>
          </div>

          <!-- sa1 end -->
          <!-- sa2 start -->
          <div class="row mt-3">
            <div class="col-sm-12 mt--20">
              <b-form-input
                type="text"
                v-model="newCustomer.PrimaryContact.Address.Line2"
                class="form-control underline mt-2"
                :class="{ 'is-invalid': submitted && $v.newCustomer.PrimaryContact.Address.Line2.$error }"
              />
              <div
                  class="invalid-feedback"
                  v-if="submitted && !$v.newCustomer.PrimaryContact.Address.Line2.maxLength"
              >Line 2 of the address must not exceed 40 characters</div>
            </div>
          </div>

          <!-- sa2 end -->
          <!-- town / city start -->
          <div class="row mt-3">
            <div class="col-12 col-xl-4">
              <label for="primaryTown">
                Town/City:
                <span v-if="!$v.newCustomer.PrimaryContact.Address.Town.required">*</span>
              </label>
            </div>
            <div class="col-12 col-xl-8 mt--20">
              <b-form-input
                id="primaryTown"
                type="text"
                v-model="newCustomer.PrimaryContact.Address.Town"
                class="form-control underline mt-2"
                :class="{ 'is-invalid': submitted && $v.newCustomer.PrimaryContact.Address.Town.$error }"
              />
              <div
                v-if="submitted && !$v.newCustomer.PrimaryContact.Address.Town.required"
                class="invalid-feedback"
              >Please provide a town/city.</div>
            </div>
          </div>
          <!-- town / city end -->
          <!-- postcode start -->
          <div class="row mt-3">
            <div class="col-12 col-xl-4">
              <label for="primaryPostcode">
                Postcode:
                <span v-if="!$v.newCustomer.PrimaryContact.Address.Postcode.required">*</span>
              </label>
            </div>
            <div class="col-12 col-xl-8 mt--20">
              <b-form-input
                id="primaryPostcode"
                type="text"
                v-model="newCustomer.PrimaryContact.Address.Postcode"
                class="form-control underline mt-2"
                :class="{ 'is-invalid': submitted && $v.newCustomer.PrimaryContact.Address.Postcode.$error }"
              />
              <div
                v-if="submitted && !$v.newCustomer.PrimaryContact.Address.Postcode.required"
                class="invalid-feedback"
              >Please provide a postcode</div>
              <div
                class="invalid-feedback"
                v-if="!$v.newCustomer.PrimaryContact.Address.Postcode.minLength"
              >Postcode must contain at least {{$v.newCustomer.PrimaryContact.Address.Postcode.$params.minLength.min}} characters.</div>
            </div>
          </div>
          <!-- postcode end -->
          <div class="row d-flex">
            <div class="col-lg-6 align-self-center no-pad">
              <div class="form-check-inline d-flex">
                <div class="p-2 align-self-center">
                  <span class="d-inline">
                    <label class="form-check-label radio_style" for="sameAsPrimaryContact">
                      <input
                        @click="setBillingContact"
                        type="checkbox"
                        class="form-check-input"
                        id="sameAsPrimaryContact"
                        :checked="!sameAsPrimary"
                      />
                      <span class="default"></span>
                    </label>
                  </span>
                </div>
                <div class="align-self-center pl-2">
                  <span class="d-inline">Provide an alternative billing contact</span>
                </div>
              </div>
            </div>
            <!-- <div class="col-lg-6 align-self-center no-pad">
              <div class="form-check-inline d-flex">
                <div class="p-2 align-self-center"> <span class="d-inline">
                    <label class="form-check-label radio_style" for="enterContactDetails">
                      <input @click="setNewContact" type="radio" class="form-check-input radio_style" id="enterContactDetails"
                        :checked="!sameAsPrimary" />
                      <span class="default"></span>
                    </label>
                  </span>
                </div>
                <div class="align-self-center pl-2">
                  <span class="d-inline">Enter contact details</span>
                </div>
              </div>
            </div>-->
          </div>
          <!-- tc end -->
        </div>
      </div>
      <!-- row close -->
      <hr />
      <div class="row pb-2" v-if="!sameAsPrimary">
        <div class="col-md-6">
          <div class="row">
            <div class="col-12">
              <h5>Billing Contact</h5>
            </div>
          </div>
          <!-- Default to same as primary contact -->
          <div>
            <div class="row mt-3">
              <!-- jt start -->
              <div class="col-12 col-xl-4">
                <label for="billingJobTitle">
                  Job title:
                  <span
                    v-if="newCustomer.BillingContact.JobTitle == '' && newCustomer.BillingContact.FirstName == '' && newCustomer.BillingContact.LastName == ''"
                  >*</span>
                </label>
              </div>
              <div class="col-12 col-xl-8 mt--20">
                <b-form-input
                  id="billingJobTitle"
                  type="text"
                  v-model="newCustomer.BillingContact.JobTitle"
                  class="form-control underline mt-2"
                  :class="{ 'is-invalid': submitted && $v.newCustomer.BillingContact.JobTitle.$error }"
                />
                <div
                  v-if="submitted && !$v.newCustomer.BillingContact.JobTitle.required"
                  class="invalid-feedback"
                >Please provide a job title.</div>
              </div>
            </div>
            <!-- jt end -->
            <!-- title start -->
            <div class="row mt-4">
              <div class="col-12 col-xl-4 my-auto">
                <label for="billingTitle">Title:</label>
              </div>
              <div class="col-12 col-xl-8">
                <div class="btn-group d-block w-100">
                  <div class="form-group my-auto">
                    <b-form-select
                      id="billingTitle"
                      v-model="newCustomer.BillingContact.Title"
                      class="form-control"
                    >
                      <option>Mr</option>
                      <option>Mrs</option>
                      <option>Ms</option>
                      <option>Miss</option>
                    </b-form-select>
                  </div>
                </div>
              </div>
            </div>
            <!-- title end -->
            <!-- fn start -->
            <div class="row mt-3">
              <div class="col-12 col-xl-4">
                <label for="billingFirstName">
                  First name:
                  <span
                    v-if="newCustomer.BillingContact.JobTitle == '' && newCustomer.BillingContact.FirstName == '' && newCustomer.BillingContact.LastName == ''"
                  >*</span>
                </label>
              </div>
              <div class="col-12 col-xl-8 mt--20">
                <b-form-input
                  id="billingFirstName"
                  type="text"
                  v-model="newCustomer.BillingContact.FirstName"
                  class="form-control underline mt-2"
                  :class="{ 'is-invalid': submitted && $v.newCustomer.BillingContact.FirstName.$error }"
                />
                <div
                  v-if="submitted && !$v.newCustomer.BillingContact.FirstName.required"
                  class="invalid-feedback"
                >Please provide a first name.</div>
              </div>
            </div>
            <!-- fn end -->
            <!-- ln start -->
            <div class="row mt-3">
              <div class="col-12 col-xl-4">
                <label for="billingLastName">
                  Last name:
                  <span
                    v-if="newCustomer.BillingContact.JobTitle == '' && newCustomer.BillingContact.FirstName == '' && newCustomer.BillingContact.LastName == ''"
                  >*</span>
                </label>
              </div>
              <div class="col-12 col-xl-8 mt--20">
                <b-form-input
                  id="billingLastName"
                  type="text"
                  v-model="newCustomer.BillingContact.LastName"
                  class="form-control underline mt-2"
                  :class="{ 'is-invalid': submitted && $v.newCustomer.BillingContact.LastName.$error }"
                />
                <div
                  v-if="submitted && !$v.newCustomer.BillingContact.LastName.required"
                  class="invalid-feedback"
                >Please provide a last name.</div>
              </div>
            </div>
            <!-- ln end -->
            <!-- landline start -->
            <div class="row mt-3">
              <div class="col-12 col-xl-4">
                <label for="billingLandline">
                  Landline:
                  <span
                    v-if="newCustomer.CustomerType == 'Consumer' && newCustomer.BillingContact.Landline == '' && newCustomer.BillingContact.Mobile == '' && newCustomer.BillingContact.Email == ''"
                  >*</span>
                </label>
              </div>
              <div class="col-12 col-xl-8 mt--20">
                <b-form-input
                  id="billingLandline"
                  type="text"
                  v-model="newCustomer.BillingContact.Landline"
                  class="form-control underline mt-2"
                  :class="{ 'is-invalid': submitted && $v.newCustomer.BillingContact.Landline.$error }"
                />
                <div
                  v-if="submitted && !$v.newCustomer.BillingContact.Landline.required"
                  class="invalid-feedback"
                >Please provide a landline.</div>
              </div>
            </div>
            <!-- landline end -->
            <!-- mobile start -->
            <div class="row mt-3">
              <div class="col-12 col-xl-4">
                <label for="billingMobile">
                  Mobile:
                  <span
                    v-if="newCustomer.CustomerType == 'Consumer' && newCustomer.BillingContact.Landline == '' && newCustomer.BillingContact.Mobile == '' && newCustomer.BillingContact.Email == ''"
                  >*</span>
                </label>
              </div>
              <div class="col-12 col-xl-8 mt--20">
                <b-form-input
                  id="billingMobile"
                  type="text"
                  v-model="newCustomer.BillingContact.Mobile"
                  class="form-control underline mt-2"
                  :class="{ 'is-invalid': submitted && $v.newCustomer.BillingContact.Mobile.$error }"
                />
                <div
                  v-if="submitted && !$v.newCustomer.BillingContact.Mobile.required"
                  class="invalid-feedback"
                >Please provide a mobile phone number.</div>
              </div>
            </div>
            <!-- mobile end -->
            <div class="row mt-3">
              <!-- fax start -->
              <div class="col-12 col-xl-4">
                <label for="billingFax">Fax:</label>
              </div>
              <div class="col-12 col-xl-8 mt--20">
                <input
                  id="billingFax"
                  v-model="newCustomer.BillingContact.Fax"
                  type="number"
                  step="1"
                  maxlength="30"
                  class="form-control underline mt-2"
                />
              </div>
            </div>
            <!-- fax end -->
            <!-- email start -->
            <div class="row mt-3">
              <div class="col-12 col-xl-4">
                <label for="billingEmail">
                  Email:
                  <span
                    v-if="newCustomer.CustomerType == 'Consumer' && newCustomer.BillingContact.Landline == '' && newCustomer.BillingContact.Mobile == '' && newCustomer.BillingContact.Email == ''"
                  >*</span>
                </label>
              </div>
              <div class="col-12 col-xl-8 mt--20">
                <b-form-input
                  id="billingEmail"
                  type="text"
                  v-model="newCustomer.BillingContact.Email"
                  class="form-control underline mt-2"
                  :class="{ 'is-invalid': submitted && $v.newCustomer.BillingContact.Email.$error }"
                />
                <div
                  class="invalid-feedback"
                  v-if="!$v.newCustomer.BillingContact.Email.email"
                >Please enter a valid email address.</div>
                <div
                  class="invalid-feedback"
                  v-if="submitted && !$v.newCustomer.BillingContact.Email.required"
                >Please provide an email address.</div>
              </div>
            </div>
            <!-- email end -->
          </div>
        </div>
        <!-- col 6 close -->

        <div class="col-md-6">
          <!--  -->
          <div class="row justify-content-center">
            <div class="col">
              <b-form-radio
                inline
                @click="copyPrimaryAddress"
                id="sameAsSiteAddress"
                value="billingAndSiteAddressesAreEqual"
                v-model="billingAddressState"
              >Copy Site Address</b-form-radio>
            </div>
            <div class="col">
              <b-form-radio
                inline
                @click="enterBillingAddress"
                id="enterBillingAddress"
                value="billingAndSiteAddressesAreNotEqual"
                v-model="billingAddressState"
              >Enter Billing Address</b-form-radio>
            </div>
          </div>
          <!-- Check but I think this should default to enter billing address  -->
          <div v-if="!copyAddress">
            <!-- sa1 start -->
            <div class="row mt-3">
              <!-- sa1 start -->
              <div class="col-12 col-xl-4">
                <label for="billingLine1">
                  Street address:
                  <span
                    v-if="!$v.newCustomer.BillingContact.Address.Line1.required"
                  >*</span>
                </label>
              </div>
              <div class="col-12 col-xl-8 mt--20">
                <input
                  id="billingLine1"
                  type="text"
                  class="form-control underline mt-2"
                  name="Street Address"
                  v-model="newCustomer.BillingContact.Address.Line1"
                  :class="{ 'is-invalid': submitted && $v.newCustomer.BillingContact.Address.Line1.$error }"
                />
                <div
                  class="invalid-feedback"
                  v-if="!$v.newCustomer.BillingContact.Address.Line1.required"
                >Please provide a street address.</div>
                <div
                    class="invalid-feedback"
                    v-if="submitted && !$v.newCustomer.BillingContact.Address.Line1.maxLength"
                >Line 1 of the address must not exceed 40 characters</div>
              </div>
            </div>
            <!-- sa1 end -->
            <!-- sa2 start -->
            <div class="row mt-3">
              <div class="col-sm-12 mt--20">
                <b-form-input
                  type="text"
                  v-model="newCustomer.BillingContact.Address.Line2"
                  class="form-control underline mt-2"
                  :class="{ 'is-invalid': submitted && $v.newCustomer.BillingContact.Address.Line2.$error }"
                />
                <div
                    class="invalid-feedback"
                    v-if="submitted && !$v.newCustomer.BillingContact.Address.Line2.maxLength"
                >Line 2 of the address must not exceed 40 characters</div>
              </div>
            </div>
            <!-- sa2 end -->
            <!-- town / city start -->
            <div class="row mt-3">
              <div class="col-12 col-xl-4">
                <label for="billingTown">
                  Town/City:
                  <span v-if="!$v.newCustomer.BillingContact.Address.Town.required">*</span>
                </label>
              </div>
              <div class="col-12 col-xl-8 mt--20">
                <b-form-input
                  id="billingTown"
                  type="text"
                  v-model="newCustomer.BillingContact.Address.Town"
                  class="form-control underline mt-2"
                  :class="{ 'is-invalid': submitted && $v.newCustomer.BillingContact.Address.Town.$error }"
                />
                <div
                  v-if="submitted && !$v.newCustomer.BillingContact.Address.Town.required"
                  class="invalid-feedback"
                >Please provide a town/city.</div>
              </div>
            </div>
            <!-- town / city end -->
            <!-- postcode start -->
            <div class="row mt-3">
              <div class="col-12 col-xl-4">
                <label for="postcodebc">
                  Postcode:
                  <span v-if="!$v.newCustomer.BillingContact.Address.Postcode.required">*</span>
                </label>
              </div>
              <div class="col-12 col-xl-8 mt--20">
                <b-form-input
                  type="text"
                  v-model="newCustomer.BillingContact.Address.Postcode"
                  id="postcodebc"
                  name="postcodebc"
                  class="form-control underline mt-2"
                  :class="{ 'is-invalid': submitted && $v.newCustomer.BillingContact.Address.Postcode.$error }"
                />
                <div
                  v-if="submitted && !$v.newCustomer.BillingContact.Address.Postcode.required"
                  class="invalid-feedback"
                >Please provide a postcode.</div>
                <div
                  class="invalid-feedback"
                  v-if="!$v.newCustomer.BillingContact.Address.Postcode.minLength"
                >Postcode must contain at least {{$v.newCustomer.BillingContact.Address.Postcode.$params.minLength.min}} characters.</div>
              </div>
            </div>
            <!-- postcode end -->
          </div>
        </div>
      </div>
      <!-- row close -->
    </div>

    <div class="modal-footer">
      <div class="row">
        <div class="col-12">
          <button type="submit" class="btn btn-hc float-left mr-2" @click="back">
            <i class="fas fa-caret-left"></i> Back
          </button>
          <button type="submit" class="btn btn-hc float-right ml-2" @click="next">
            Next
            <i class="fas fa-caret-right"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
	required,
	email,
	minLength,
	maxLength,
	decimal,
	minValue,
} from 'vuelidate/lib/validators';
import Vue from 'vue';

import { uuid } from 'vue-uuid';

export default {
  data() {
    return {
      submitted: false,
      billingAddressState: "billingAndSiteAddressesAreNotEqual",
      newCustomer: {
        CollectionDueDays: null,
        PaymentDueDays: null,
        CustomerType: "Landlord",
        CustomerName: "",
        BillingGroups: "",
        CollectionMethod: "",
        RegularCollectionAmount:"",
        DaysOfMonth: undefined,
        BillDeliveryMethods: "",
        PrimaryContact: {
          Id: uuid.v1(),
          Address: {
            Line1: "",
            Line2: "",
            Town: "",
            Postcode: "",
          },
          JobTitle: "", 
          Title: "",
          FirstName: "",
          LastName: "",
          Landline: "",
          Mobile: "",
          Email: "",
        },
        BillingContact: {
          Id: uuid.v1(),
          Address: {
            Line1: "",
            Line2: "",
            Town: "",
            Postcode: "",
          },
          JobTitle: "",
          Title: "",
          FirstName: "",
          LastName: "",
          Landline: "",
          Mobile: "",
          Email: "",
        },
      },
      searchId: "",
      searchResultFields: {
        ref: {
          key: "Document.CustomerReference",
          label: "Customer Reference",
          sortable: true,
          class: "text-center",
        },
        name: {
          key: "Document.CustomerName",
          label: "Customer Name",
          sortable: true,
          class: "text-center",
        },
        address: {
          key: "Document.Addresses[0]",
          label: "Customer Address",
          class: "text-center",
        },
      },
      selectedCustomer: {
        ref: {
          key: "CustomerReference",
          label: "Customer Reference",
          class: "text-center",
        },
        name: {
          key: "CustomerName",
          label: "Customer Name",
          class: "text-center",
        },
        address: {
          key: "PrimaryContact.Address.Line1",
          label: "Customer Address",
          class: "text-center",
        },
      },
    };
  },
  validations() {
    return {
      newCustomer: {
        CustomerType: {
          required,
        },
        CustomerName: {
          required,
          maxLength: maxLength(40),
        },
        BillingGroups: {
          required,
        },
        CollectionMethod: {
          required,
        },
        RegularCollectionAmount:
          this.newCustomer.CollectionMethod === "DDFIX"
            ? { required, decimal, minValue: minValue(0.01)}
            : {},
        DaysOfMonth:
          this.newCustomer.CollectionMethod === "DDFIX"
            ? { required, minLength: minLength(1) }
            : {},
        BillDeliveryMethods: {
          required,
        },
        PrimaryContact: {
          Address: {
            Line1: {
              required,
              maxLength: maxLength(40),
            },
            Line2: {
              maxLength: maxLength(40),
            },
            Town: {
              required,
              maxLength: maxLength(40),
            },
            Postcode: {
              required,
              minLength: minLength(6),
              maxLength: maxLength(8),
            },
          },
          JobTitle:
            this.newCustomer.PrimaryContact.FirstName == "" &&
            this.newCustomer.PrimaryContact.LastName == ""
              ? { required, maxLength: maxLength(30) }
              : { maxLength: maxLength(30) },
          FirstName:
            this.newCustomer.PrimaryContact.JobTitle == "" &&
            this.newCustomer.PrimaryContact.LastName == ""
              ? { required, maxLength: maxLength(15) }
              : { maxLength: maxLength(15) },
          LastName:
            this.newCustomer.PrimaryContact.JobTitle == "" &&
            this.newCustomer.PrimaryContact.FirstName == ""
              ? { required, maxLength: maxLength(30) }
              : { maxLength: maxLength(30) },
          Landline:
            this.newCustomer.CustomerType == "Consumer" &&
            this.newCustomer.PrimaryContact.Mobile == "" &&
            this.newCustomer.PrimaryContact.Email == ""
              ? { required, maxLength: maxLength(30) }
              : { maxLength: maxLength(30) },
          Mobile:
            this.newCustomer.CustomerType == "Consumer" &&
            this.newCustomer.PrimaryContact.Landline == "" &&
            this.newCustomer.PrimaryContact.Email == ""
              ? { required, maxLength: maxLength(30) }
              : { maxLength: maxLength(30) },
          Email:
            this.newCustomer.CustomerType == "Consumer" &&
            this.newCustomer.PrimaryContact.Landline == "" &&
            this.newCustomer.PrimaryContact.Mobile == ""
              ? { required, email, maxLength: maxLength(254) }
              : { email, maxLength: maxLength(254) },
        },
        BillingContact: {
          Address: {
            Line1: this.sameAsPrimary
              ? ""
              : {
                  required,
                  maxLength: maxLength(40),
                },
            Line2: this.sameAsPrimary
                ? ""
                : {
                  maxLength: maxLength(40),
                },
            Town: this.sameAsPrimary
              ? ""
              : {
                  required,
                  maxLength: maxLength(40),
                },
            Postcode: this.sameAsPrimary
              ? ""
              : {
                  required,
                  minLength: minLength(6),
                  maxLength: maxLength(8),
                },
          },
          JobTitle: this.sameAsPrimary
            ? ""
            : this.newCustomer.BillingContact.FirstName == "" &&
              this.newCustomer.BillingContact.LastName == ""
            ? { required, maxLength: maxLength(30) }
            : { maxLength: maxLength(30) },
          FirstName: this.sameAsPrimary
            ? ""
            : this.newCustomer.BillingContact.JobTitle == "" &&
              this.newCustomer.BillingContact.LastName == ""
            ? { required, maxLength: maxLength(15) }
            : { maxLength: maxLength(15) },
          LastName: this.sameAsPrimary
            ? ""
            : this.newCustomer.BillingContact.JobTitle == "" &&
              this.newCustomer.BillingContact.FirstName == ""
            ? { required, maxLength: maxLength(30) }
            : { maxLength: maxLength(30) },
          Landline: this.sameAsPrimary
            ? ""
            : this.newCustomer.CustomerType == "Consumer" &&
              this.newCustomer.BillingContact.Mobile == "" &&
              this.newCustomer.BillingContact.Email == ""
            ? { required, maxLength: maxLength(30) }
            : { maxLength: maxLength(30) },
          Mobile: this.sameAsPrimary
            ? ""
            : this.newCustomer.CustomerType == "Consumer" &&
              this.newCustomer.BillingContact.Landline == "" &&
              this.newCustomer.BillingContact.Email == ""
            ? { required, maxLength: maxLength(30) }
            : { maxLength: maxLength(30) },
          Email: this.sameAsPrimary
            ? ""
            : this.newCustomer.CustomerType == "Consumer" &&
              this.newCustomer.BillingContact.Landline == "" &&
              this.newCustomer.BillingContact.Mobile == ""
            ? { required, email, maxLength: maxLength(254) }
            : { email, maxLength: maxLength(254) },
        },
      },
    };
  },
  computed: {
		billingGroupsOptions() {
			const supplierId = Vue.config.honeycomb.supplierId;
			if (['DUAL', 'SEBL'].includes(supplierId)) {
				return [
					{ name: 'Monthly', value: 'Monthly' },
					{ name: 'Electricity', value: 'Electricity' },
				];
			} else {
				return [
					{ name: 'Key Accounts', value: 'KeyAccounts' },
					{ name: 'Non Key Accounts', value: 'NonKeyAccounts' },
				];
			}
		},
    copyAddress() {
      return this.billingAddressState === "billingAndSiteAddressesAreEqual";
    },
    results() {
      return this.$store.state.results;
    },
    destinationCustomer() {
      return this.$store.state.transfer.destinationCustomer;
    },
    createCustomer: {
      get() {
        return this.$store.state.transfer.createCustomer;
      },
      set(bool) {
        this.submitted = false;
        this.$store.commit("updateCreateCustomer", bool);
      },
    },
    sameAsPrimary: {
      get() {
        return this.$store.state.transfer.sameAsPrimary;
      },
      set(bool) {
        this.$store.commit("updateSameAsPrimary", bool);
      },
    },
    billingGroups() {
      let that = this;
      // If filterByBillingGroups is true returns billing groups filtered by service type, if not returns all billing groups
      return Vue.config.honeycomb.filterByBillingGroups
        ? this.$_.filter(Vue.config.honeycomb.billingGroups, (billingGroup) => {
            return that.serviceTypes.includes(billingGroup.name);
          })
        : Vue.config.honeycomb.billingGroups;
    },
    transferServices() {
      return this.$store.state.transfer.transferServices;
    },
    serviceTypes() {
      let serviceTypes = [];
      this.transferServices.forEach((service) => {
        serviceTypes.push(service.Service.ServiceType);
      });
      return this.$_.uniq(serviceTypes);
    },

		collectionMethod: {
			get() {
				return this.newCustomer.CollectionMethod;
			},
			set(val) {
				if (val === 'DDFIX') {
					this.regularCollectionMethod = undefined;
					this.daysOfMonth = undefined;
				}

				this.newCustomer.CollectionMethod = val;
			},
		},

		regularCollectionAmount: {
			get() {
				return this.newCustomer.RegularCollectionAmount;
			},
			set(val) {
				if (val === '' || Number.isNaN(+val)) {
					this.newCustomer.RegularCollectionAmount = val;
				} else {
					this.newCustomer.RegularCollectionAmount = +val;
				}
			},
		},

		daysOfMonth: {
			get() {
				return this.newCustomer.DaysOfMonth;
			},
			set(val) {
				this.newCustomer.DaysOfMonth = val;
			},
		},

    dayOpts() {
      return (new Array(31)).fill(null).map((v, i) => i + 1)
    },
    collectionDueDays: {
      get() {
        if (!this.$store.state.customers.account) return;

        return this.newCustomer.CollectionDueDays
        || Vue.config.honeycomb.moneybot.defaultCollectionDueDays
      },
      set(val){
        if (val == Vue.config.honeycomb.moneybot.defaultCollectionDueDays) this.newCustomer.CollectionDueDays = null;
        else this.newCustomer.CollectionDueDays = val
      }
    },
    paymentDueDays:{
      get() {
        if (!this.$store.state.customers.account) return;

        return this.newCustomer.PaymentDueDays
        || Vue.config.honeycomb.moneybot.defaultPaymentDueDays
      },
      set(val){
        if (val == Vue.config.honeycomb.moneybot.defaultPaymentDueDays) this.newCustomer.PaymentDueDays = null;
        else this.newCustomer.PaymentDueDays = val
      }
    },
		collectionMethods() {
			return Vue.config.honeycomb.collectionMethods || [];
		},
  },
  methods: {
    refreshTransfer() {
      this.$store.commit("refreshTransfer");
    },
    next() {
      this.submitted = true;
      if (!this.createCustomer && this.destinationCustomer) {
        this.$emit("next");
        this.$emit("next");
      } else {
        this.$v.$touch();
        if (!this.$v.$invalid) {
          this.$store.commit("updateDestinationCustomer", this.newCustomer);
          if (
            this.newCustomer.CollectionMethod !== "DDVAR" &&
            this.newCustomer.CollectionMethod !== "DDFIX"
          ) {
            // If the user has navigated back and selected cash, we need to reset the back details
            this.$store.commit("resetTransferBankDetails");
            this.$emit("next");
          }
          this.$emit("next");
        }
      }
    },
    back() {
      this.$emit("back");
    },
    search: function () {
      this.$store.dispatch("search", this.searchId);
    },
    setDestinationCustomer: function (result) {
      this.$store.dispatch("setDestinationCustomer", result.Document);
      this.createCustomer = false;
      this.searchId = "";
      this.$store.commit("resetResults");
    },
    createNewCustomer() {
      this.createCustomer = true;
      this.sameAsPrimary = true;
      this.newCustomer = {
        CustomerType: "",
        CustomerName: "",
        BillingGroups: "Monthly",
        BillDeliveryMethods: "",
        CollectionMethod: "",
        RegularCollectionAmount:"",
        DaysOfMonth: undefined,
        PrimaryContact: {
          Id: uuid.v1(),
          Address: {
            Line1: "",
            Line2: "",
            Town: "",
            Postcode: "",
          },
          JobTitle: "",
          Title: "",
          FirstName: "",
          LastName: "",
          Landline: "",
          Mobile: "",
          Email: "",
        },
        BillingContact: {
          Id: uuid.v1(),
          Address: {
            Line1: "",
            Line2: "",
            Town: "",
            Postcode: "",
          },
          JobTitle: "",
          Title: "",
          FirstName: "",
          LastName: "",
          Landline: "",
          Mobile: "",
          Email: "",
        },
      };
      this.newCustomer.BillingGroups = this.billingGroups[0].value;

			this.$store.commit('updateDestinationCustomer', this.newCustomer);
			this.searchId = '';
			this.$store.commit('resetResults');
		},
		setBillingContact: function() {
			this.sameAsPrimary = !this.sameAsPrimary;
			this.newCustomer.BillingContact = {
				Id: uuid.v1(),
				Address: {
					Line1: '',
					Line2: '',
					Town: '',
					Postcode: '',
				},
				JobTitle: '',
				Title: '',
				FirstName: '',
				LastName: '',
				Landline: '',
				Mobile: '',
				Email: '',
			};
		},
		copyPrimaryAddress() {
			this.billingAddressState === 'billingAndSiteAddressesAreEqual';
			this.newCustomer.BillingContact.Address = this.newCustomer.PrimaryContact.Address;
		},
		enterBillingAddress() {
			this.billingAddressState === 'billingAndSiteAddressesAreNotEqual';
			this.newCustomer.BillingContact.Address = {
				Line1: '',
				Line2: '',
				Town: '',
				Postcode: '',
			};
		},
	},
};
</script>
